import { useAgencyCampaignContext } from '../agencyCampaignContext';
import { AgencyCampaignSection } from '../../agency/model';
import { SupplyTab } from './supplyRouteSearch';
import { Link, useRouterState, useSearch } from '@tanstack/react-router';
import { cn } from '@shigo-ui/ui';

import { dashboardT } from '../../../lib/messages';

const tabs = [
  { tab: SupplyTab.Apps, to: '/campaigns/supply/apps', label: 'supply.tabs.apps' },
  { tab: SupplyTab.Domains, to: '/campaigns/supply/domains', label: 'supply.tabs.domains' },
  {
    tab: SupplyTab.Tailored,
    to: '/campaigns/supply/tailored-supply',
    label: 'supply.tabs.tailored',
  },
] as const;

export function SupplyTabs() {
  const scope = useAgencyCampaignContext();
  const search = useSearch({ strict: false });
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  return (
    <nav
      aria-label={dashboardT('supply.title')}
      className="border-border bg-card page-gutter border-b"
    >
      <div className="flex min-w-max gap-1 overflow-x-auto">
        {tabs.map(({ to, label, tab }) => {
          const isActive = scope
            ? (search.supplyTab ?? SupplyTab.Apps) === tab
            : pathname.startsWith(to);

          return (
            <Link
              key={to}
              to={scope ? '/a/$agencyId/campaigns/$section' : to}
              params={{ agencyId: scope?.agency.id ?? '', section: AgencyCampaignSection.Supply }}
              search={scope ? { supplyTab: tab } : {}}
              aria-current={isActive ? 'page' : undefined}
              className={cn(
                'text-muted-foreground border-b-2 border-transparent px-3 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                isActive && 'shigo-supply-tab--active',
              )}
            >
              {dashboardT(label)}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
